import { css } from 'styled-components';
import { cssVar } from 'src/app/styles/helper';
import { mediaQuery } from 'src/app/styles/helper';
import { TypographySize } from './Heading.styles';

export const paragraphXl = css`
  font-size: ${cssVar('font-size-text-xl')};
  line-height: ${cssVar('line-height-text-xl')};
  font-weight: ${cssVar('font-weight-regular')};

  ${mediaQuery(
    'md',
    css`
      font-size: ${cssVar('font-size-text-lg')};
      line-height: ${cssVar('line-height-text-lg')};
    `
  )}
`;

export const paragraphLg = css`
  font-size: ${cssVar('font-size-text-lg')};
  line-height: ${cssVar('line-height-text-lg')};
  font-weight: ${cssVar('font-weight-regular')};
`;

export const paragraphMd = css`
  font-size: ${cssVar('font-size-text-md')};
  line-height: ${cssVar('line-height-text-md')};
  font-weight: ${cssVar('font-weight-regular')};
`;

export const paragraphSm = css`
  font-size: ${cssVar('font-size-text-sm')};
  line-height: ${cssVar('line-height-text-sm')};
  font-weight: ${cssVar('font-weight-regular')};
`;

export const paragraphXs = css`
  font-size: ${cssVar('font-size-text-xs')};
  line-height: ${cssVar('line-height-text-xs')};
  font-weight: ${cssVar('font-weight-regular')};
`;

export const PARAGRAPH_STYLES: Record<Exclude<TypographySize, '2xl'>, ReturnType<typeof css>> = {
  xl: paragraphXl,
  lg: paragraphLg,
  md: paragraphMd,
  sm: paragraphSm,
  xs: paragraphXs,
};
